module.exports = __webpack_public_path__ + "10964daa4ab7ac98ca47870da48ee94d.pdf";